import { useEffect, useState } from "react";
import styles from "./PixelSentence.module.css";
import { capitalLetterComponents } from "./PixelLetters";
import sounds, { SFX } from "../../classes/Sounds";
import { useKeyPress } from "../../hooks/useKeyPress";

export default function PixelSentence({
  centeredText = false,
  textString = "This is the default text.",
  onDone,
  preDelayMs = 10,
}) {
  const totalLength = textString.split(" ").join("").length;
  const [revealedCount, setRevealedCount] = useState(-1);
  const [canStart, setCanStart] = useState(false);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setCanStart(true);
    }, preDelayMs);
    return () => {
      clearTimeout(timeout);
    };
  }, [preDelayMs]);

  useEffect(() => {
    if (!canStart) {
      return;
    }

    if (revealedCount >= totalLength - 1) {
      return;
    }
    const delay = 80;

    const timeout = setTimeout(() => {
      setRevealedCount(revealedCount + 1);
      sounds.playSfx(SFX.TALK_BLIP);
    }, delay);

    return () => {
      clearTimeout(timeout);
    };
  }, [revealedCount, totalLength, canStart]);

  const handleUserInteractWithPrompt = () => {
    if (revealedCount >= totalLength - 1) {
      onDone();
      return;
    }
    setRevealedCount(totalLength);
  };
  useKeyPress("Enter", () => {
    handleUserInteractWithPrompt();
  });

  const words = textString.toUpperCase().split(" ");

  let globalCount = 0;

  return (
    <div className={styles.sentence} onClick={handleUserInteractWithPrompt}>
      <div
        className={styles.wordsContainer}
        style={{
          justifyContent: centeredText ? "center" : "flex-start",
        }}
      >
        {words.map((wordString, i) => {
          return (
            <span className={styles.word} key={i}>
              {wordString.split("").map((char, i) => {
                globalCount += 1;
                return (
                  <span
                    style={{
                      opacity: revealedCount >= globalCount - 1 ? 1 : 0,
                    }}
                    key={i}
                  >
                    {capitalLetterComponents[char]}
                  </span>
                );
              })}
            </span>
          );
        })}
      </div>
    </div>
  );
}
